module.exports = __webpack_public_path__ + "static/media/Artboard6.d24ea571.png";